// extracted by mini-css-extract-plugin
module.exports = {"redHederText":"competition_redHederText__3FxDU","blueHederText":"competition_blueHederText__nz5lp","redText":"competition_redText__6tHn3","blueText":"competition_blueText__eDRPw"};